import { Button } from "@artha/ui";
import { LogOut } from "lucide-react";
import { useLogout } from "@/modules/auth/hooks/useLogout";

interface LogoutButtonProps {
  variant?: "default" | "ghost" | "outline" | "secondary" | "destructive" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  showIcon?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const LogoutButton = ({ 
  variant = "ghost", 
  size = "default",
  showIcon = true,
  children = "Logout",
  className 
}: LogoutButtonProps) => {
  const { logout, isLoading } = useLogout();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={logout}
      disabled={isLoading}
      className={className}
    >
      {showIcon && <LogOut className="w-4 h-4 mr-2" />}
      {children}
    </Button>
  );
};